import { CirclePlus } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/button'
import { TestimonialsCard } from '@/components/testimonials/testimonials-card'
import { Testimonial } from '@/models/testimonial'

interface TestimonialsHomeSectionProps {
  testimonials: Testimonial[]
  handleOpenModal(testimonial: Testimonial): void
}

export function TestimonialsHomeSection({
  testimonials,
  handleOpenModal,
}: TestimonialsHomeSectionProps) {
  return (
    <div className="flex flex-col items-center gap-8 lg:gap-14">
      <span className="title">Resultados reais para quem preserva</span>

      <div className="flex w-full flex-col flex-wrap justify-around gap-6 px-2 md:flex-row md:px-0 2xl:justify-between">
        {testimonials.map((testimony) => (
          <TestimonialsCard
            className="sm:w-min"
            key={testimony.id_depoimento}
            testimonial={testimony}
            handleOpenModal={() => handleOpenModal(testimony)}
          />
        ))}
      </div>

      <Link to="/be-guardian">
        <Button
          className="text-monochromatic-400 flex items-center gap-2 font-semibold uppercase disabled:border-none disabled:bg-transparent"
          variant="ghost"
        >
          <CirclePlus size={20} />
          Veja mais depoimentos
        </Button>
      </Link>
    </div>
  )
}
